import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '@app/directives';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {TooltipModule} from "ngx-bootstrap";
import {ActivityAddTagComponent} from "@app/shared/activity-add-tag/activity-add-tag.component";

@NgModule({
    declarations: [
        ActivityAddTagComponent,
    ],
    exports: [
        ActivityAddTagComponent,
    ],
    imports: [
        CommonModule,
        DirectivesModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        TooltipModule,
    ],
    entryComponents: []
})
export class ActivityAddTagModule {
}
